import React, { createContext, useState, useContext } from 'react';

const CurrencyContext = createContext();

const EXCHANGE_RATES = {
  USD: 1,
  HTG: 135,
  EUR: 0.92,
  CAD: 1.35,
  GBP: 0.79,
  DOP: 60.50,
  CLP: 980,
  CHF: 0.88,
  XOF: 605,
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState('USD');

  const convertPrice = (priceInUSD) => {
    return (priceInUSD * EXCHANGE_RATES[currency]).toFixed(2);
  };

  const getCurrencySymbol = () => {
    const symbols = {
      USD: '$',
      HTG: 'G',
      EUR: '€',
      CAD: 'C$',
      GBP: '£',
      DOP: 'RD$',
      CLP: 'CL$',
      CHF: 'CHF',
      XOF: 'CFA',
    };
    return symbols[currency] || '$';
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, convertPrice, getCurrencySymbol, EXCHANGE_RATES }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);